import type { ThemeColors, ThemePreset } from '../types';
import { sharedTokens } from '../tokens';

export const darkColors: ThemeColors = {
  background: '222 60% 12%',
  foreground: '210 40% 96%',
  card: '219 56% 16%',
  cardForeground: '210 40% 96%',
  popover: '219 56% 16%',
  popoverForeground: '210 40% 96%',
  primary: '145 55% 78%',
  primaryForeground: '145 82% 18%',
  secondary: '219 40% 18%',
  secondaryForeground: '210 40% 96%',
  muted: '219 32% 20%',
  mutedForeground: '214 20% 72%',
  accent: '219 32% 22%',
  accentForeground: '210 40% 96%',
  destructive: '8 68% 55%',
  destructiveForeground: '0 0% 100%',
  border: '219 28% 26%',
  input: '219 28% 26%',
  ring: '219 80% 70%',
  sidebar: '219 56% 16%',
  sidebarForeground: '210 40% 96%',
  sidebarBorder: '219 28% 26%',
  sidebarAccent: '219 40% 18%',
  success: '149 65% 54%',
  warning: '43 75% 55%',
  info: '209 100% 68%',
  brandAccent: '219 80% 70%',
  brandAccentForeground: '222 60% 12%',
  authGradientWarm: '219 56% 16%',
  authGradientCool: '222 60% 12%',
  authAccentBlue: '219 80% 70%',
  authAccentGreen: '145 55% 62%',
  authShadow: '222 60% 12%',
};

export const darkTheme: ThemePreset = {
  name: 'dark',
  colors: darkColors,
  ...sharedTokens,
  shadow: {
    notion:
      'rgba(12, 122, 58, 0.20) 0px 8px 32px, rgba(12, 122, 58, 0.12) 0px 0px 0px 1px',
    notionLg:
      'rgba(12, 122, 58, 0.30) 0px 12px 40px, rgba(12, 122, 58, 0.15) 0px 0px 0px 1px',
    toast: '0 8px 24px rgba(12, 122, 58, 0.25)',
  },
};
